import React, { useEffect } from 'react'
import GoBack from '../../components/goBack'
import { Box, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Text, useDisclosure, useToast } from '@chakra-ui/react'
import { useState } from 'react'
import CustomInput from '../../components/customInput/customInput'
import CustomSelect from '../../components/customSelect/customSelect'
import PrimaryButton from '../../components/primaryButton/primarybutton'
import countriesData from '../../utils/countries.json'
import axiosInstance from '../../services/api'
import { useSelector } from 'react-redux'

const AccountInfo = () => {
    const [interestOptions, setInterestOptions] = useState([]);
    const [loading, setLoading] = useState()
    const [loadingz, setLoadingz] = useState()
  const [defaultCountry, setDefaultCountry] = useState('')

  const currentUser = useSelector(({ userData }) => userData?.currentUser);
//   const { isOpen = true, onOpen, onClose } = useDisclosure();
  const [isOpen, setIsOpen] = useState(currentUser?.activationInterests?.length < 1);

  const [profileData, setProfileData] = useState({
    firstName: currentUser?.firstName,
    lastName: currentUser?.lastName,
    email: currentUser?.email,
    country: currentUser?.country,
    state: currentUser?.state,
    area: currentUser?.localGovernment,
    town: currentUser?.town,
    address: currentUser?.address,
    phone: currentUser?.phoneNumber,
    interests: currentUser?.activationInterests
  })

  const toast = useToast();

   useEffect(() => {
          // Fetch the user's country using ipinfo.io
          fetch("https://ipinfo.io/json?token=1920c15b6512bf")
            .then((response) => response.json())
            .then((data) => {
              const countryName = data.country; // ISO country code
              // const countryFullName = data.country_name || countryName; // Full country name (depends on the service used)
              console.log(countryName)
              // Format the response
              setDefaultCountry(countryName);
            })
            .catch((error) => console.error("Error fetching location:", error));
        }, []);

    

    const getInterestOptions = async() => {
        setLoadingz(true)
        try {
            const { data } = await axiosInstance.get('/employees/activation-interest-options')
            setInterestOptions(data?.data)
        } catch(error) {
            console.error(error)
        } finally {
            setLoadingz(false)
        }
    }

    useEffect(() => {
        getInterestOptions()
    }, [])

  const countries = countriesData?.map(x => ({
    title: x?.name,
    value: x?.name?.toLowerCase(),
    code: x?.code2,
    states: x?.states
  }))

  const places2 = countries?.find(x => x?.value === (profileData?.country || "nigeria"))?.states?.map(i => ({
    title: i?.name,
    value: i?.name?.toLowerCase(),
    listValue: i?.subdivision?.map(i => ({
      title: i,
      value: i,
    }))
  })) || []

  const update = async(e) => {
    e.preventDefault();

    if(profileData?.interests?.length > 0) {
        setLoading(true)

    const datax = {
        firstName: profileData?.firstName,
        lastName: profileData?.lastName,
        email: profileData?.email,
        phoneNumber: profileData?.phone.charAt(0) === "0"
        ? "+234" + profileData?.phone.slice(1)
        : profileData?.phone.charAt(0) === "+" ? profileData?.phone : "+234" + profileData?.phone,
        country: profileData?.country,
        address: profileData?.address,
        state: profileData?.state,
        localGovernment: profileData?.area,
        town: profileData?.town,
        role: currentUser?.role,
        profilePicture: currentUser?.profilePicture,
        activationInterests: profileData?.interests
    }

    try {
        const {data} = await axiosInstance.patch(`/employees/${currentUser?._id}`, datax)
        console.log("test",data)
        toast({
            description: data?.message,
            status: "success",
            position: "top-right",
            duration: 5000,
            isClosable: true,
          });
          window.location.href = '/'
    } catch(error) {
        console.log(error?.response?.data?.message)
        toast({
            title: "An Error Occurred",
            description: error?.response?.data?.message,
            status: "error",
            position: "top-right",
            duration: 5000,
            isClosable: true,
          });
    } finally {
        setLoading(false)
    }
    } else {
        toast({
            title: "An Error Occurred",
            description: 'Please select at least one activation interest',
            status: "error",
            position: "top-right",
            duration: 5000,
            isClosable: true,
          });
    }
}

  const handleSelect = (val) => {
    if(!profileData?.interests?.includes(val)) {
        setProfileData({...profileData, interests: [...profileData?.interests, val]})
    } else {
        const filtered = profileData?.interests?.filter(i => i !== val)
        setProfileData({...profileData, interests: filtered})
    }
}


  return (
    <>
    <GoBack />
    <Box p="1rem">
        <Text fontWeight={"500"} fontSize={"1.2rem"} mb=".4rem">Account Information</Text>
        <Text fontWeight={"500"} opacity={'.7'} fontSize={".95rem"} mb="1.5rem">Complete your profile information</Text>
        <form onSubmit={update}>
                    <Flex gap=".8rem">
                    <CustomInput
                    type={"text"}
                    placeholder={"First Name"}
                    mb={".8rem"}
                    value={profileData?.firstName}
                    // onChange={e => setProfileData({...profileData, firstName: e.target.value})}
                    />
                    <CustomInput 
                    type={"text"}
                    placeholder={"Last Name"}
                    mb={".8rem"}
                    value={profileData?.lastName}
                    // onChange={e => setProfileData({...profileData, lastName: e.target.value})}
                    />
                    </Flex>
                    <CustomInput 
                    type={"email"}
                    placeholder={"Email Address"}
                    mb={".8rem"}
                    value={profileData?.email}
                    />
                    <Flex mb=".8rem" gap={".8rem"}>
                    <CustomSelect
                        options={[{title: countries?.find(x => x?.code === defaultCountry)?.title, value: countries?.find(x => x?.code === defaultCountry)?.value}, ...countries]}
                        placeholder={profileData?.country}
                        onChange={e => setProfileData({...profileData, country: e.target.value})}
                    />
                    <CustomSelect
                        options={places2}
                        placeholder={profileData?.state || 'Select'}
                        onChange={e => setProfileData({...profileData, state: e.target.value})}
                    />
                    
                    </Flex>

                    <Flex mb=".8rem" gap={".8rem"}>
                    <CustomSelect
                        options={places2?.filter(i => i.value === profileData?.state)[0]?.listValue}
                        placeholder={profileData?.area || 'Select'}
                        onChange={e => setProfileData({...profileData, area: e.target.value})}
                    />
                    <CustomInput
                        type={"text"}
                        placeholder='Town'
                        value={profileData?.town}
                        onChange={e => setProfileData({...profileData, town: e.target.value})}
                    />
                    
                    </Flex>
                    <CustomInput 
                    type={"text"}
                    placeholder='Address'
                    mb={".8rem"}
                    value={profileData?.address}
                    onChange={e => setProfileData({...profileData, address: e.target.value})}
                    />
                    <CustomInput 
                    type={"tel"}
                    placeholder={"Phone Number"}
                    mb={".8rem"}
                    minLength={"11"}
                    maxLength={"11"}
                    value={profileData?.phone}
                    onChange={e => setProfileData({...profileData, phone: e.target.value})}
                    />
                    <Text mt={".7rem"} opacity={.7} fontSize={".8rem"}>Select One or more activation interests</Text>
                    <Flex gap=".7rem" flexWrap={"wrap"} mt=".8rem">
                        {interestOptions?.map(i => {
                            return (
                                <Text cursor={"pointer"} onClick={() => handleSelect(i)} padding={'.45rem'} borderRadius={'12px'} border={profileData?.interests?.includes(i) ? '2px solid green' : '1px solid lightgray'} fontSize={"12px"} fontWeight={"500"}>{i}</Text>
                            )
                        })}
                    </Flex>
                    <br /><br /><br />
                    <PrimaryButton type="submit" text="Update Profile" mb="6rem" func={() => {}} loading={loading} />
                </form>

                <Modal isCentered motionPreset='slideInBottom' isOpen={isOpen} closeOnOverlayClick={false} onClose={() => setIsOpen(false)}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader fontSize={"1rem"} textTransform={"capitalize"}>{'Why are you seeing this?'}</ModalHeader>
                        <ModalBody>
                            <>
                                <Text textAlign={"center"} color={"#475467"} fontWeight={"500"} mb={"1rem"}>We have updated our account requirements and we now need you to complete your profile information, Please fill all fields and submit.</Text>
                                <Flex justifyContent={"center"} my="1.3rem">
                                <PrimaryButton text="Continue" onClick={() => setIsOpen(false)} width="150px" padding="1rem !important" loading={false} />
                                </Flex>
                            </>
                        </ModalBody>
                    </ModalContent>
                </Modal>
    </Box>
    </>
  )
}

export default AccountInfo